module.exports = __webpack_public_path__ + "static/media/XMLID_71_new loanx3.2004ffe5.svg";